import { ace_index } from '@axo/shared/data-access/types';
import { Divider } from '@blueprintjs/core';
import { UseQueryResult } from 'react-query';
import { IconButton } from '../IconButton';
import classes from './SearchPaginate.module.css';

interface SearchPaginateProps {
  query: UseQueryResult<ace_index.FindResult, unknown>;
  firstPage: (() => void) | undefined;
  lastPage: (() => void) | undefined;
  nextPage: (() => void) | undefined;
  previousPage: (() => void) | undefined;
  disabledNext: boolean | undefined;
  disabledPrevious: boolean | undefined;
}

export function SearchPaginate({ config }: { config: SearchPaginateProps }) {
  const {
    query,
    firstPage,
    lastPage,
    nextPage,
    previousPage,
    disabledNext,
    disabledPrevious,
  } = config;
  return (
    <div className={classes.footer}>
      {query.data && (
        <span>
          {query.data.Parameters.TotalPages === 0
            ? 0
            : query.data.Parameters.PageNumber}{' '}
          of {query.data.Parameters.TotalPages ?? 0}
        </span>
      )}
      <Divider />
      <nav className={classes.nav}>
        <IconButton
          classes={{ container: classes.navButton }}
          icon="chevron-backward"
          title="First"
          onClick={firstPage}
          disabled={disabledPrevious}
        />
        <IconButton
          classes={{ container: classes.navButton }}
          icon="chevron-left"
          title="Prev"
          onClick={previousPage}
          disabled={disabledPrevious}
        />

        <IconButton
          classes={{ container: classes.navButton }}
          icon="chevron-right"
          title="Next"
          onClick={nextPage}
          disabled={disabledNext}
        />
        <IconButton
          classes={{ container: classes.navButton }}
          icon="chevron-forward"
          title="Last"
          onClick={lastPage}
          disabled={disabledNext}
        />
      </nav>
    </div>
  );
}
